<template>
  <div class="logo-bye py-2 py-lg-3">
    <img class="img-fluid w-40 w-md-30 w-lg-15" src="@/assets/img/Icons-02.svg" alt="logo">
  </div>
  <div class="d-none d-md-block">
    <img src="https://papaimages.s3.ap-northeast-1.amazonaws.com/papaevent/goodbye/PC.jpg" alt="" class="img-fluid w-100">
  </div>
  <div class="d-block d-md-none">
    <img src="https://papaimages.s3.ap-northeast-1.amazonaws.com/papaevent/goodbye/MB.jpg" alt="" class="img-fluid w-100">
  </div>
</template>

<style scoped>
.logo-bye{
  display: flex;
  justify-content: center;
}
</style>
